import { TCreateConverter, TFetchConverter } from 'data/types/Converter.types';
import { getFirstLetters } from 'data/convertors/General.converters';
import { landlordStatusConverter } from 'data/convertors/Landlord.converters';
import {
  TCreatedPartnerApiIntegrationAppDB,
  TCreatedPartnerApiIntegrationAppUI,
  TCreatePartnerApiIntegrationAppDB,
  TCreatePartnerApiIntegrationAppUI,
  TPartnerApiAppLandlordDB,
  TPartnerApiAppLandlordUI,
  TPartnerApiAppWebhookSubscriptionDB,
  TPartnerApiAppWebhookSubscriptionUI,
  TCreatePartnerApiAppWebhookSubscriptionDB,
  TCreatePartnerApiAppWebhookSubscriptionUI,
  TPartnerApiIntegrationAppDB,
  TPartnerApiIntegrationAppUI,
} from 'data/types/partnerApiIntegrationApp.types';

export const partnerApiIntegrationAppConverter: TFetchConverter<
  TPartnerApiIntegrationAppUI,
  TPartnerApiIntegrationAppDB
> = {
  fromDb: data => ({
    id: data.id,
    name: data.name,
    logoUrl: data.logoUrl,
    description: data.description,
    apiKey: data.apiKey ?? null,
    includeFuture: data.visibleToFuturePropertyManagements,
  }),
};

export const partnerApiIntegrationAppsConverter: TFetchConverter<
  TPartnerApiIntegrationAppUI[],
  TPartnerApiIntegrationAppDB[]
> = {
  fromDb: data => (data || []).map(partnerApiIntegrationAppConverter.fromDb),
};

export const createPartnerApiIntegrationAppConverter: TCreateConverter<
  TCreatePartnerApiIntegrationAppUI,
  TCreatePartnerApiIntegrationAppDB
> = {
  toDb: data => ({
    name: data.name,
    logoUrl: data.logoUrl,
    description: data.description,
    visibleToFuturePropertyManagements: data.includeFuture,
    propertyManagementIds: data.propertyManagementIds,
  }),
};

export const partnerApiAppLandlordConverter: TFetchConverter<
  TPartnerApiAppLandlordUI,
  TPartnerApiAppLandlordDB
> = {
  fromDb: data => ({
    id: data.id,
    name: data.name,
    status: landlordStatusConverter.fromDb(data.status),
    visible: data.visible,
    connected: data.connected,
    firstLetters: getFirstLetters(data.name || ''),
  }),
};

export const partnerApiAppLandlordsConverter: TFetchConverter<
  TPartnerApiAppLandlordUI[],
  TPartnerApiAppLandlordDB[]
> = {
  fromDb: data => (data || []).map(partnerApiAppLandlordConverter.fromDb),
};

export const partnerApiAppWebhookSubscriptionConverter: TFetchConverter<
  TPartnerApiAppWebhookSubscriptionUI,
  TPartnerApiAppWebhookSubscriptionDB
> = {
  fromDb: data => ({
    id: data.id,
    eventType: data.eventType,
    url: data.url,
  }),
};

export const createPartnerApiAppWebhookSubscriptionConverter: TCreateConverter<
  TCreatePartnerApiAppWebhookSubscriptionUI,
  TCreatePartnerApiAppWebhookSubscriptionDB
> = {
  toDb: data => ({
    eventType: data.eventType,
    url: data.url,
  }),
};

export const createdPartnerApiIntegrationAppConverter: TFetchConverter<
  TCreatedPartnerApiIntegrationAppUI,
  TCreatedPartnerApiIntegrationAppDB
> = {
  fromDb: data => ({
    id: data.id,
    apiKey: data.apiKey,
    sandbox: data.sandbox,
  }),
};